import BaseButton from 'components/common/BaseButton';
import BaseText from 'components/common/BaseText';
import { memo, useCallback, useEffect, useRef } from 'react';
import srcLogo from 'assets/images/logo.png';
import {
  StepStartWrapper,
  StepStartTitle,
  StepStartButtonPart,
} from './StepStart.styled';
import { useDispatch, useSelector } from 'react-redux';
import { nextStep } from 'store/slices/global.slice';
import AnimateTop from 'components/AnimateTop';
import { BsClockFill } from 'react-icons/bs';
import { tagManager } from 'utils/tagManager';

const StepStart = () => {
  const dispatch = useDispatch();
  const { firstName, customer_type } = useSelector((state) => state.form);
  const startBtnRef = useRef(null);

  const onKeyDown = useCallback(
    (e) => {
      if (e.nativeEvent.keyCode === 13) {
        dispatch(nextStep());
      }
    },
    [dispatch]
  );

  useEffect(() => {
    startBtnRef.current.focus();
  }, []);

  const onClickStart = useCallback(() => {
    dispatch(nextStep());
    tagManager('sr_form', {
      app_name: 'reactForm',
      screen_name: 'start',
      customer_type: customer_type,
      // event_callback: function () { },
    });
  }, [dispatch, customer_type]);

  return (
    <>
      <AnimateTop y={window.innerWidth < 768 ? '100px' : '100%'}>
        <StepStartWrapper>
          <img src={srcLogo} alt='Logo' />
          <StepStartTitle type='big'>
            {`Hello${
              firstName ? ` ${firstName},` : `,`
            } please respond to a few questions to get your service request
            started:`}
          </StepStartTitle>
          <StepStartButtonPart>
            <div>
              <BaseButton
                type='start'
                onKeyDown={onKeyDown}
                onClick={onClickStart}
                ref={startBtnRef}
              >
                <BaseText type='big' fw={700}>
                  Start
                </BaseText>
              </BaseButton>
              <span>press Enter ↵</span>
            </div>
            <div>
              <BsClockFill />
              <BaseText fw={500}>Takes 3 mins</BaseText>
            </div>
          </StepStartButtonPart>
        </StepStartWrapper>
      </AnimateTop>
    </>
  );
};

export default memo(StepStart);
